import { render, staticRenderFns } from "./WebhookFakeFidel.vue?vue&type=template&id=97f93ea0&scoped=true&"
import script from "./WebhookFakeFidel.vue?vue&type=script&lang=ts&"
export * from "./WebhookFakeFidel.vue?vue&type=script&lang=ts&"
import style0 from "./WebhookFakeFidel.vue?vue&type=style&index=0&id=97f93ea0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97f93ea0",
  null
  
)

export default component.exports